<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <form [formGroup]="webpageForm">
    <div class="webPages-acoordion">
      <div class="dash-webPages-top1">
        <a
          [ngClass]="{ active: SelectedWebType == 'termsAndConditions' }"
          (click)="AssignWebPageType('termsAndConditions')"
          >Terms & Conditions</a
        >
        <a
          [ngClass]="{ active: SelectedWebType == 'about' }"
          (click)="AssignWebPageType('about')"
          >About</a
        >
        <a
          [ngClass]="{ active: SelectedWebType == 'cancellationPolicy' }"
          (click)="AssignWebPageType('cancellationPolicy')"
          >Cancellation Policy</a
        >
        <a
          [ngClass]="{ active: SelectedWebType == 'refundPolicy' }"
          (click)="AssignWebPageType('refundPolicy')"
          >Refund Policy
        </a>
        <a
          [ngClass]="{ active: SelectedWebType == 'privacyPolicy' }"
          (click)="AssignWebPageType('privacyPolicy')"
          >Privacy Policy
        </a>
        <a
          [ngClass]="{ active: SelectedWebType == 'accountDeletion' }"
          (click)="AssignWebPageType('accountDeletion')"
          >Account Deletion
        </a>
      </div>
    </div>
    <div class="webPageContent">
      <angular-editor
        formControlName="webpage_string"
        [config]="config"
      ></angular-editor>
    </div>
    <div>
      <button
        type="button"
        [class.spinner]="loading"
        [disabled]="loading"
        class="button buttonBlue mt-3 web_pages"
        (click)="saveWeb()"
      >
        save
      </button>
    </div>
  </form>
</div>
